import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));

// Lazy load per diem pages
const PerDiemPage = lazy(() => import('@/pages/per-diem'));
const CreatePerDiemPage = lazy(() => import('@/pages/per-diem/create'));
const UpdatePerDiemPage = lazy(() => import('@/pages/per-diem/[per-diemId]/update'));

/**
 * Per Diem routes
 * Handles per diem management
 */
export const perDiemRoutes: RouteConfig = {
  path: '/per-diem',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      element: PerDiemPage,
    },
    {
      path: '/create',
      element: CreatePerDiemPage,
    },
    {
      path: '/:perDiemId/update',
      element: UpdatePerDiemPage,
    },
  ],
};
